/**
 * Valeurs alignées sur variables.scss via tokens-export.module.scss
 * (évite de dupliquer les listes de tones / presets dans chaque composant).
 */
import tokens from '@/assets/styles/tokens-export.module.scss';

function parseExportedList(value) {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) return Object.freeze(value.map(String));
  // Sass peut interpoler une liste en "a, b, c" ou "a b c" selon la version
  return Object.freeze(
    String(value)
      .trim()
      .split(/[\s,]+/)
      .filter(Boolean),
  );
}

export const TONES = parseExportedList(tokens.tones);
export const PRESETS = parseExportedList(tokens.presets);
export const SIZES = parseExportedList(tokens.sizes);

export function isTone(value) {
  return typeof value === 'string' && TONES.includes(value);
}

export function isPreset(value) {
  return typeof value === 'string' && PRESETS.includes(value);
}

export function isSize(value) {
  return typeof value === 'string' && SIZES.includes(value);
}
